module.exports = __webpack_public_path__ + "static/gem-essential-visa-nz-6587660ca7fe0e4acabb95b87ef8f43c.png";